export default __webpack_public_path__ + "static/media/plus_collapse.99fd7540.svg";